import script from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./TableStylePanel.vue?vue&type=style&index=0&id=d7008912&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7008912"]])

export default __exports__